import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'wen-icon-edit',
  templateUrl: './edit.component.html',
  styleUrls: ['./edit.component.less'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class EditIconComponent {}
